<section class="collapse-card--container" #collapseCard>
    <div class="collapse--wrapper {{isCollapse ? 'collapsed': ''}}" [ngStyle]="{'height': viewHeight+'px'}">
        <header class="collapse--header">
            <h2 class="header--title float-left  font-weight-bold text-left">{{header}}</h2>
            <div (click)="toggleCollapse()" class="collapse--button {{isCollapse ? 'collapsed' : ''}}">
                <i class="fas fa-chevron-up"></i>
            </div>
        </header>
        <div class="collaspe--content">
            <ng-content>
            </ng-content>
        </div>
    </div>
</section>